import { IOrganization, ITokens, Products } from '@formstack/unified-header';

import { IUserInfo } from '@/common/dto/auth/UserInfo/Interface';

export const getOrganizationDetails = (user: IUserInfo | undefined): IOrganization => ({
  canAccessSubaccounts: user?.canAccessSubaccounts ?? false,
  currentOrg: {
    id: user?.organizationId ?? '',
    name: user?.organization?.name ?? '',
    logoUrl: '',
  },
  parentOrg: user?.parentOrg,
});

export const getUserCopilotRole = (user: IUserInfo | undefined) =>
  user?.platformRoles?.find((role) => role.productId === Products.Copilot)?.role ?? '';

export const getUserFeatureSet = (user: IUserInfo | undefined) => user?.featureSet ?? [];

export const getUserPlatformRoles = (user: IUserInfo | undefined) => user?.platformRoles ?? [];

export const getUserTokens = (user: IUserInfo | undefined): ITokens => ({
  sid: user?.sid ?? '',
  sidHmac: user?.sidHmac ?? '',
});

export const isUserOrganizationAdmin = (user: IUserInfo | undefined): boolean =>
  !!getUserPlatformRoles(user).find(
    (role) => role.productId === 'organization' && role.role === 'admin'
  );

export const isUserAdmin = (user: IUserInfo | undefined): boolean =>
  getUserCopilotRole(user) === 'admin';

export const isUserParticipant = (user: IUserInfo | undefined): boolean =>
  getUserCopilotRole(user) === 'workspace_user';

export const userHasAccessTo = (feature: string, user: IUserInfo | undefined): boolean =>
  getUserFeatureSet(user).includes(feature);
